module.exports = __webpack_public_path__ + "static/media/CC-2.132500ea.PNG";